// extracted by mini-css-extract-plugin
module.exports = {"formGroup":"textarea_formGroup__1ugCt","input":"textarea_input__16p8w","error":"textarea_error__3UDmS"};